@if (this.value) {
  <cam-billing-amount style="line-height: normal; font-weight: bold" [amount]="this.value!" display="amount" />
}
